/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид новости в каталоге.
   * @param {number} page Номер страницы к которой привязана новость.
   */
  app.CategoryNewsItemView = app.View.extend({
    additionalOptions: ['page'],

    isClosed: false,

    events: {
      'click .js-news-closer': 'close',
    },

    /** @inheritDoc */
    run: function () {
      this.model.set('isMobile', app.isMobile);
      this.template = app.helpers.TemplateHelper.getTemplate('#news-item-template');
    },

    /**
     * Закрывает новость.
     */
    close: function () {
      this.toggle();
      this.isClosed = true;
    },

    /**
     * Возвращает элемент с новостью.
     * @return {HTMLElement} Элемент с новостью.
     */
    render: function () {
      if (!this.isClosed) {
        var $el = $(this.template(this.model.toJSON()));
        this.setElement($el[0]);
        return this.el;
      }
    }
  });
})();

}.call(window));